//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formulaDetail } from '../../../server/oldformula/'
export default {
  name: 'PIROVAP_info',
  data () {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: '1691746860944'
    }
  },
  methods: {
    async getFormulaDetail () {
      var params = {
        uuid: this.id
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain)
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.id = this.$route.query.uuid ? this.$route.query.uuid : this.id
    this.getFormulaDetail()
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ID/PIROVAP_info.vue